(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('vvWordBreak', function($sanitize, $filter, vv) {
    var region = vv.getVvMetaData('region');
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        attrs.$observe('vvWordBreak', function(value) {
          if (!value) {
            element.text('');
            return;
          }

          // escape html element
          var nodes = $.parseHTML($sanitize(value));
          var text = $(nodes[0]).text();

          if (region == 'kr') {
            // insert wbr tag after possible word break characters nad wrap word with nowrap tag
            text = $filter('wordBreak')(text);
          }

          element.html(text);
        });
      }
    };
  });
})(window, window.angular);
